export default __webpack_public_path__ + "static/media/gallery2.7878249d.jpg";